import react from "react";
import {Helmet} from "react-helmet-async"
function about() {
    <Helmet>
   <title>Cimeza Africa</title>
   <meta name="description" 
   content="Cimeza Africa SEO & Digital Marketing Agency, social media, branding ,web design and mobile application development, events"
   data-rh="true"/>

  <link rel="canonical" href="https://www.cimeza-africa.com/" />
  <link rel="alternate" href="https://www.cimeza-africa.com/" hreflang="en-eg" />
  <meta property="og:title" content="Cimeza Africa the Digital Marketing Agency social media, branding web design&amp; events | cimeza" />
  <meta property="og:description"
  content="Cimeza Africa, SEO & Digital Marketing Agency, social media, branding ,web design and mobile application development, events" />
  <meta property="og:url" content="https://www.cimeza-africa.com/" />
  <meta property="og:site_name" content="Cimeza Africa" />
<link rel="canonical"  href="/about"/>
        
</Helmet> 
    return (
        <>
            {/* <!-- Start Breadcrumb ============================================= --> */}
            <div className="breadcrumb-area bg-gradient text-center">
                <div className="fixed-bg"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <h1>About Us</h1>
                            <ul className="breadcrumb">
                                <li><a href="#"><i className="fas fa-home"></i> Home</a></li>
                                <li><a href="#">Pages</a></li>
                                <li className="active">About Us</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Breadcrumb --> */}

            {/* <!-- Star About Area ============================================= --> */}
            <div className="about-area default-padding">
                <div className="container">
                    <div className="about-items">
                        <div className="row">
                            <div className="col-lg-6 thumb wow fadeInUp">
                                <img src="assets/img/illustration/14.png" alt="Cimeza Africa"/>
                            </div>
                            <div className="col-lg-6 info wow fadeInLeft">
                                <h5>About Us</h5>
                                <h2>An award winning <br/> <strong>Digital services agency</strong></h2>
                                <p>
                                    Agreed but expect repair she nay sir silent person. Direction can dependent one bed situation attempted. His she are man their spite avoid. Her pretended fulfilled extremely education yet. Satisfied did one admitting incommode tolerably how are.
                                </p>
                                <div className="progress-items">
                                    <div className="progress-box">
                                        <h5>Search Engine Optimization <span className="float-right">88%</span></h5>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" data-width="87"></div>
                                        </div>
                                    </div>
                                    <div className="progress-box">
                                        <h5>Marketing Analysis <span className="float-right">70%</span></h5>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" data-width="52"></div>
                                        </div>
                                    </div>
                                    {/* <!-- End Progressbar --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End About Area --> */}

            {/* <!-- Start Process  ============================================= --> */}
            <div className="our-process-area default-padding-bottom bottom-less">
                <div className="container">
                    <div className="process-box text-center">
                        <div className="row">
                            {/* <!-- Single Item --> */}
                            <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="500ms">
                                    <div className="icon">
                                        <i className="fas fa-chart-line"></i>
                                    </div>
                                    <h4>Research</h4>
                                    <p>
                                        Welcome fat who window. Removing welcomed civility or hastened.
                                    </p>
                                </div>
                            </div>
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="600ms">
                                    <div className="icon">
                                        <i className="fas fa-hdd"></i>
                                    </div>
                                    <h4>Data Collection</h4>
                                    <p>
                                        Welcome fat who window. Removing welcomed civility or hastened.
                                    </p>
                                </div>
                            </div>
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="700ms">
                                    <div className="icon">
                                        <i className="fas fa-bullseye"></i>
                                    </div>
                                    <h4>Targeting</h4>
                                    <p>
                                        Welcome fat who window. Removing welcomed civility or hastened.
                                    </p>
                                </div>
                            </div>
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="800ms">
                                    <div className="icon">
                                        <i className="fas fa-list-alt"></i>
                                    </div>
                                    <h4>Result</h4>
                                    <p>
                                        Welcome fat who window. Removing welcomed civility or hastened.
                                    </p>
                                </div>
                            </div>
                            {/* <!-- End Single Item --> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Process --> */}

            {/* <!-- Start Clients ============================================= --> */}
            <div className="clients-area bg-gray default-padding">
                <div className="container">
                    <div className="row align-center">
                        <div className="col-lg-5 info">
                            <h2>We've Worked With Them, <strong> Now Trust Each</strong> Other</h2>
                        </div>
                        <div className="col-lg-7">
                            <div className="clients-carousel owl-carousel owl-theme">
                                <div className="item">
                                    <img src="assets/img/clients/1.png" alt="Cimeza Africa"/>
                                </div>
                                <div className="item">
                                    <img src="assets/img/clients/2.png" alt="Cimeza Africa"/>
                                </div>
                                <div className="item">
                                    <img src="assets/img/clients/3.png" alt="Cimeza Africa"/>
                                </div>
                                <div className="item">
                                    <img src="assets/img/clients/4.png" alt="Cimeza Africa"/>
                                </div>
                                <div className="item">
                                    <img src="assets/img/clients/5.png" alt="Cimeza Africa"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Clients --> */}

            {/* <!-- Start Why Choose Us ============================================= --> */}
            <div className="choose-us-area default-padding-bottom bg-gray">
                <div className="container">
                    <div className="row align-center">
                        <div className="col-lg-6 thumb wow fadeInRight">
                            <img src="assets/img/illustration/7.png" alt="Cimeza Africa"/>
                        </div>
                        <div className="col-lg-6 info wow fadeInUp">
                            <h2>We Offer a Full Range of <br/> <strong>Digital Marketing</strong> Services!</h2>
                            <p>
                                Greatly explain attempt perhaps in feeling he. House men taste bed not drawn joy. Through enquire however do equally herself at.
                            </p>
                            <p>
                                Picture removal detract earnest is by. Esteems met joy attempt way clothes yet demesne tedious. Replying an marianne do it an entrance advanced. Two dare say play when hold. Required bringing me material stanhill jointure is as he. Mutual indeed yet her living result matter him bed whence.
                            </p>
                            <a className="btn circle btn-md btn-gradient">Start a Project</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Why Choose Us --> */}

            {/* <!-- Start Team  ============================================= --> */}
            {/* <div className="team-area default-padding bottom-less">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="site-heading text-center">
                                <h5>Our Team</h5>
                                <h2>
                                    Meet our professional & Expert <br/>Team Members
                                </h2>
                                <div className="heading-divider"></div>
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="team-items text-center">
                        <div className="row"> */}
                            {/* <!-- Single Item --> */}
                            {/* <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="500ms">
                                    <div className="thumb">
                                        <img src="assets/img/team/1.jpg" alt="Thumb"/>
                                    </div>
                                    <div className="info">
                                        <span>Senior Marketer</span>
                                        <h4>Jonathom Ahem</h4>
                                        <div className="contact">
                                            <i className="fab fa-twitter"></i>
                                            <a href="#">twitter.com/digilab46</a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            {/* <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="600ms">
                                    <div className="thumb">
                                        <img src="assets/img/team/2.jpg" alt="Thumb"/>
                                    </div>
                                    <div className="info">
                                        <span>Sales Manager</span>
                                        <h4>Donald Busri</h4>
                                        <div className="contact">
                                            <i className="fab fa-twitter"></i>
                                            <a href="#">twitter.com/digilab46</a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            {/* <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="700ms">
                                    <div className="thumb">
                                        
                                    </div>
                                    <div className="info">
                                        <span>Data Analyst</span>
                                        <h4>Sami Adham</h4>
                                        <div className="contact">
                                            <i className="fab fa-twitter"></i>
                                            <a href="#">twitter.com/digilab46</a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- End Single Item --> */}
                            {/* <!-- Single Item --> */}
                            {/* <div className="single-item col-lg-3 col-md-6">
                                <div className="item wow fadeInUp" data-wow-delay="800ms">
                                    <div className="thumb">
                                        <img src="assets/img/team/4.jpg" alt="Thumb"/>
                                    </div>
                                    <div className="info">
                                        <span>Managing Director</span>
                                        <h4>Munns Tenul</h4>
                                        <div className="contact">
                                            <i className="fab fa-twitter"></i>
                                            <a href="#">twitter.com/digilab46</a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <!-- End Single Item --> */}
                        {/* </div>
                    </div>
                </div>
            </div> */}
            {/* <!-- End Team --> */}
        </>
    );
}

export default about;